import React, { useContext, useMemo, useCallback } from 'react';
import { dataSender, getRoute, navigateV2 } from '../../../common/utils/router';
import { svgSprite, Img } from '../../../hybrid/wrappers';
import CartCounter from '../CartCounter/CartCounter';
import UserContext, { StoreContext, UserProfileContext } from '../../../common/utils/getContext';
import T from '../../../common/components/T';
import { API_SERVER_URL } from '../../../common/utils/utils';
import { useRouter } from 'next/router';
import css from './CartItemGridAdmin.module.scss';
import classnames from 'classnames';
import Display from '../../../common/components/Display';

const CartItemGridAdmin = ({ item, price = false, article = false, funcs, type = '' }) => {
    const router = useRouter();
    const { userToken, lang, setAlertData, localization, currencies, marketingCurrency } = useContext(UserContext);
    const { profileData, adminPage: onlyShow } = useContext(UserProfileContext);
    const { cartData, setCartData, deliveryCurrency } = useContext(StoreContext) || {};
    const deleteProduct = async () => {
        if (cartData.id) {
            dataSender(
                `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/delete-product?_method=DELETE`,
                'POST',
                { product_id: item.product.id },
                (response) => {
                    setCartData(response.data?.data);
                    if (router.asPath === getRoute('/store/cart') && !response?.data?.data?.items?.length) {
                        navigateV2('/store');
                    }
                },
                () => {
                    setAlertData({
                        type: 'error',
                        cont: true,
                        default: 'error_delete_data'
                    });
                },
                userToken,
                lang,
                deliveryCurrency || profileData?.currency?.code || localization?.currency
            );
        }
    };
    const handleLink = () => {
        window.open(`/store/product/${item.product.id}`, '_blank');
    };

    const handleLinkSetProduct = useCallback((id) => window.open(`/store/product/${id}`, '_blank'), []);
    const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

    const actualPrice = useMemo(() => {
        let actualPrice = item.product.main_price;
        let pricesMainCurrency = item.product?.prices
            ?.filter((el) => el?.currency_id === item.product.main_price.currency_id)
            ?.sort((a, b) => b.product_count_from - a.product_count_from);
        if (pricesMainCurrency?.length) {
            actualPrice = pricesMainCurrency.find((el) => el.product_count_from <= item.quantity);
        }

        return actualPrice;
    }, [item?.product?.main_price, item.product?.prices, item?.quantity]);

    const currentCurrency = currencies.data.find((el) => el.id === item?.product?.main_price?.currency_id) || {};

    return (
        <>
            <div className={css.cartWrapperItemGridAdmin}>
                <div className={classnames(css.cartCell)}>
                    <div className={css.cartWrapperLeft}>
                        <div>
                            <div className={css.cartItemImage}>
                                {!!item?.product?.image ? (
                                    <Img className={css.imageGridItem} src={item?.product?.image?.links?.thumb} alt='image' />
                                ) : (
                                    svgSprite('plug-grid-image', {
                                        width: 48,
                                        height: 48
                                    })
                                )}
                            </div>
                        </div>
                        <div className={css.cartItemName}>
                            <div onClick={handleLink} className={css.cartItemTitle}>
                                {item.product.name}
                            </div>
                            {article && (
                                <div className={css.cartItemArticle}>
                                    <div className={css.cartItemArticleTitle}>
                                        <T textName='storeArticle' defaultStr='Артикул' page='/store' />:
                                    </div>
                                    <div>{item.product.article}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <ConditionalWrapper
                    condition={false}
                    wrapper={(children) => (
                        <div
                            className={
                                funcs
                                    ? classnames(css.cartCell, css.cartWrapperRight, css.cartWrapperRightHeader)
                                    : classnames(css.cartCell, css.cartWrapperRight)
                            }
                        >
                            {children}
                        </div>
                    )}
                >
                    <ConditionalWrapper
                        condition={false}
                        wrapper={(children) => (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                {children}
                            </div>
                        )}
                    >
                        {price && (
                            <div className={classnames(css.cartCell, css.totalPriceModernGridAdmin)}>
                                {actualPrice.price_for_client_formatted}
                            </div>
                        )}
                        <div className={css.cartCell}>
                            {onlyShow ? (
                                <p>{item.quantity}</p>
                            ) : (
                                <CartCounter
                                    count={item.quantity}
                                    idProduct={item.product.id}
                                    funcs={funcs}
                                    price={price}
                                    type={type}
                                />
                            )}
                        </div>
                        {price ? (
                            <div className={classnames(css.cartCell, css.cartItemPriceGridAdmin, css.cartItemPriceGrid)}>
                                <div className={css.totalPrice}>
                                    <Display
                                        type='value'
                                        data={{
                                            value: Number(actualPrice.price_for_client * item.quantity),
                                            formatByDecimal: true,
                                            currency: {
                                                displayed_decimals_number: currentCurrency.displayed_decimals_number,
                                                code: item.product.main_price.currency,
                                                symbol: item.product.main_price.currency_symbol
                                            }
                                        }}
                                    />
                                </div>
                                <div className={css.totalMarketingPrice}>
                                    <Display
                                        type='value'
                                        data={{
                                            value: Number((item?.marketing_price || 0) * item.quantity),
                                            currency: marketingCurrency
                                        }}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className={classnames(css.cartCell, css.cartItemPrice)}>
                                <div className={css.totalPrice}>{item.price_formatted}</div>
                                <div className={css.totalMarketingPrice}>{item.marketing_price_formatted}</div>
                            </div>
                        )}
                    </ConditionalWrapper>
                </ConditionalWrapper>
                {/* <div  onClick={() => deleteProduct()} className={css.cartItemDeleteIcon}> {svgSprite('trash')} </div> */}
                {onlyShow ? null : (
                    <div
                        onClick={funcs && funcs.del ? () => funcs.del(item.product.id) : () => deleteProduct()}
                        className={classnames(css.cartCell, css.cartItemDeleteIconWrap)}
                    >
                        {svgSprite('trash', { className: css.cartItemDeleteIcon })}
                    </div>
                )}
            </div>

            {item && item.product && item.product.set_products && item.product.set_products.length ? (
                <>
                    <div className={classnames(css.cartWrapperHead, css.cartWrapperHeadBackground)}>
                        <div
                            style={{ textAlign: 'left' }}
                            className={classnames(css.cartWrapperHeadItem, css.cartWrapperHeadItem_First)}
                        >
                            <T textName='storeProduct' defaultStr='Товар' page='/store' />
                        </div>

                        <div
                            style={{ textAlign: 'center' }}
                            className={classnames(css.cartWrapperHeadItem, css.cartWrapperHeadItemML)}
                        >
                            <T textName='storePrice' defaultStr='Цена' page='/store' />
                        </div>
                        <div style={{ textAlign: 'center' }} className={css.cartWrapperHeadItem}>
                            <T textName='storeCount' defaultStr='Кол-во' page='/store' />
                        </div>
                        <div className={classnames(css.cartWrapperHeadItem, css.cartWrapperHeadItemPrices)}>
                            <T textName='storeTotal' defaultStr='Итого' page='/store' />
                        </div>
                        <div className={classnames(css.cartWrapperHeadItem, css.cartWrapperHeadItem_Last)}></div>
                    </div>
                    {item.product.set_products.map((i) => {
                        return (
                            <div key={i.id} className={css.cartWrapperItemGridAdmin}>
                                <div className={classnames(css.cartCell)}>
                                    <div className={css.cartWrapperLeft}>
                                        <div className={css.cartItemName}>
                                            <div onClick={() => handleLinkSetProduct(i.id)} className={css.cartItemTitle}>
                                                {i.name}
                                            </div>
                                            {i.article && (
                                                <div className={css.cartItemArticle}>
                                                    <div className={css.cartItemArticleTitle}>
                                                        <T textName='storeArticle' defaultStr='Артикул' page='/store' />:
                                                    </div>
                                                    <div>{i.article}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {i.main_price?.price_for_client_formatted && (
                                    <div className={classnames(css.cartCell, css.totalPriceModernGridAdmin)}>
                                        {i.main_price?.price_for_client_formatted}
                                    </div>
                                )}
                                <div className={classnames(css.cartCell, css.totalPriceModernGridAdmin)}>{i.count}</div>
                                <div className={classnames(css.cartCell, css.cartItemPriceGridAdmin, css.cartItemPriceGrid)}>
                                    <div className={css.totalPrice}>
                                        <Display
                                            type='value'
                                            data={{
                                                value: Number(i.main_price.price_for_client * i.count),
                                                formatByDecimal: true,
                                                currency: {
                                                    displayed_decimals_number: currentCurrency.displayed_decimals_number,
                                                    code: i.main_price.currency,
                                                    symbol: i.main_price.currency_symbol
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={classnames(css.cartCell, css.cartItemDeleteIconWrap)}></div>
                            </div>
                        );
                    })}
                </>
            ) : null}
        </>
    );
};
export default CartItemGridAdmin;
